import React, { type FunctionComponent } from "react";
import c from "classnames/bind";

import styles from "./card.module.scss";
import { CardBadge } from "./card-badge";
import { CardContent } from "./card-content";
import { CardContentContainer } from "./card-content-container";
import { CardCta } from "./card-cta";
import { CardFeatureList } from "./card-feature-list";
import { CardHeading } from "./card-heading";
import { CardMedia } from "./card-media";
import { CardMediaLayout } from "./card-media-layout";
import { CardOverline } from "./card-overline";
import type { CardRootProps } from "./card-root";
import { CardRoot } from "./card-root";
export type {
  CardHeadingButtonProps,
  CardHeadingDefaultProps,
  CardHeadingLinkProps,
  CardHeadingNonInteractiveProps,
} from "./card-heading";

const cx = c.bind(styles);

type CardCmp<P> = FunctionComponent<P> & {
  Badge: typeof CardBadge;
  Content: typeof CardContent;
  ContentContainer: typeof CardContentContainer;
  Cta: typeof CardCta;
  FeatureList: typeof CardFeatureList;
  Overline: typeof CardOverline;
  Heading: typeof CardHeading;
  Media: typeof CardMedia;
  MediaLayout: typeof CardMediaLayout;
};

export type CardProps = CardRootProps;

const rootClassName = "purpur-card";

export const Card: CardCmp<CardProps> = ({ children, className, useMediaQueries, ...props }) => {
  const classes = cx([rootClassName, className]);
  return (
    <div
      className={cx(`${rootClassName}__container`, {
        [`${rootClassName}__container--full-height`]: props.fullHeight,
        [`${rootClassName}__container--use-container-queries`]: !useMediaQueries,
        [`${rootClassName}__container--use-media-queries`]: useMediaQueries,
      })}
    >
      <CardRoot className={cx(classes)} {...props}>
        {children}
      </CardRoot>
    </div>
  );
};

Card.Badge = CardBadge;
Card.Content = CardContent;
Card.ContentContainer = CardContentContainer;
Card.Cta = CardCta;
Card.FeatureList = CardFeatureList;
Card.Overline = CardOverline;
Card.Heading = CardHeading;
Card.Media = CardMedia;
Card.MediaLayout = CardMediaLayout;

Card.displayName = "Card";
